export default class FullDayEvents {
    constructor() {
        if($('.form-element-full_day').length > 0) {

            $('.form-element-event_end').hide();
            $('.form-element-event_end .form-column-minute').hide();
            $('.form-element-event_end .form-column-hours').hide();
            this.updateForm($('.form-element-full_day .custom-control-input')[0].checked);

            $('.custom-control-input').on('change', ev => this.updateForm(ev.target.checked));
        }
    }

    updateForm (value) {
        if(value) {
            $('.form-element-datetime .form-column-hours select').val('00');
            $('.form-element-datetime .form-column-minute select').val('00');
            $('.form-element-datetime .form-column-minute').fadeOut();
            $('.form-element-datetime .form-column-hours').fadeOut();
            $('.form-element-event_end').fadeIn();
            $('.form-element-datetime .form-column-date .hasDatepicker').prop('placeholder','Date de début de l\'événement');
        }
        else {
            $('.form-element-datetime .form-column-hours').fadeIn();
            $('.form-element-datetime .form-column-minute').fadeIn();
            $('.form-element-event_end').fadeOut();
            $('.form-element-datetime .form-column-date .hasDatepicker').prop('placeholder','Date l\'événement');
        }
    }
}